module.exports = __webpack_public_path__ + "static/media/aff_lab.69b33b3e.svg";